import React from 'react';
import {
  SelectionWrapper,
  CheckboxPreview,
  RadioPreview,
  SelectionLabel
} from './styles/SelectionControl.styles';

const SelectionControl = ({ control }) => {
  return (
    <SelectionWrapper styleProps={control.attributes}>
      {control.factoryKey === 'control_checkbox' ? (
        <CheckboxPreview isChecked={control.isChecked} styleProps={control.attributes} />
      ) : (
        <RadioPreview isChecked={control.isChecked} styleProps={control.attributes} />
      )}
      <SelectionLabel>
        {control.label}
      </SelectionLabel>
    </SelectionWrapper>
  );
};

export default SelectionControl;